import { BenefitTax } from "./benefit-tax.dto";
import { PayrollCompanyDto } from "./company-account.dto";
import { Country } from "./country.dto";
import {PaginatorInfo} from "./generic.dto";

export type TaxRate = {
  id: number
  countryId: number
  minTaxableAmount: number
  maxTaxableAmount: number
  rateComponent: number
  fixedComponent: number | null
  onDirectIncome: boolean
  benefitTaxId: number | null
  incomePeriod: INCOME_PERIOD
  name: string;
  companyId: number | null
  createdAt: string
  modifiedAt: string | null
}

export const INCOME_PERIOD = {
  MONTH: 'MONTH',
  YEAR: 'YEAR'
};

export type INCOME_PERIOD = (typeof INCOME_PERIOD)[keyof typeof INCOME_PERIOD]

export class CreateTaxRateDto {
  countryId!: number
  minTaxableAmount!: number
  maxTaxableAmount!: number
  rateComponent!: number
  fixedComponent?: number
  onDirectIncome!: boolean
  benefitTaxId?: number
  incomePeriod!: INCOME_PERIOD
  name!: string
  /** @ignore */ companyId?: number | null
}

export type CreateCompanyTaxRateDto
  = Omit<CreateTaxRateDto, 'countryId' | 'companyId'>;

export interface TaxRateDto extends TaxRate {
  benefitTax?: BenefitTax
  country?: Country
  company?: PayrollCompanyDto
}

export interface TaxRatePaginator extends PaginatorInfo<TaxRateDto> {}
export class UpdateTaxRateDto {
  minTaxableAmount?: number
  maxTaxableAmount?: number
  rateComponent?: number
  fixedComponent?: number
  onDirectIncome?: boolean
  benefitTaxId?: number
  incomePeriod?: INCOME_PERIOD
  name?: string
}

export class QueryTaxRateDto {
  countryId?: number;
  /** Accepts a value of 0 for non-company rates */
  companyId?: number;
  onDirectIncome?: boolean;
  benefitTaxId?: number;
  incomePeriod?: INCOME_PERIOD;
  page?: number = 1;
  limit?: number;
  orderBy?: TaxRateOrderBy = TaxRateOrderBy.CREATED_AT_ASC;
}

export enum TaxRateOrderBy {
  CREATED_AT_ASC = 'createdAt:asc',
  CREATED_AT_DESC = 'createdAt:desc',
  MODIFIED_AT_ASC = 'modifiedAt:asc',
  MODIFIED_AT_DESC = 'modifiedAt:desc'
}